exports = module.exports = require("../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".image-img-L2s {\n    max-width: 100%;\n}\n", ""]);

// Exports
exports.locals = {
	"img": "image-img-L2s"
};